import { FAQS } from "@/mocks/home";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import LiveNow from "./components/LiveNow";
import Features from "./components/Features";
import Ranking from "./components/Ranking";
import Hosts from "./components/Hosts";
import Steps from "./components/Steps";
import Reviews from "./components/Reviews";
import Faq from "./components/Faq";
import JoinForm from "./components/JoinForm";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

const ORG_JSONLD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "吃瓜快手",
  alternateName: "Chigua Live",
  description:
    "吃瓜快手直播互动平台，提供高清连麦、实时弹幕、礼物打赏与精彩回放的一站式直播吃瓜体验。",
  url: "https://shgzq.cn/",
};

const WEBSITE_JSONLD = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "吃瓜快手",
  url: "https://shgzq.cn/",
  inLanguage: "zh-CN",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://shgzq.cn/?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

const WEBPAGE_JSONLD = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "吃瓜快手直播互动平台｜连麦打赏弹幕礼物回放",
  url: "https://shgzq.cn/",
  description:
    "吃瓜快手直播互动专区，高清连麦、实时弹幕、礼物打赏、精彩回放一应俱全，实时参与吃瓜现场，与主播和网友零距离互动。",
  inLanguage: "zh-CN",
  isPartOf: WEBSITE_JSONLD,
};

const FAQ_JSONLD = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

function Schema() {
  const payloads = [ORG_JSONLD, WEBSITE_JSONLD, WEBPAGE_JSONLD, FAQ_JSONLD];
  return (
    <>
      {payloads.map((schema, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </>
  );
}

export default function Home() {
  return (
    <div className="bg-background-50 text-foreground-950 antialiased">
      <Schema />
      <Navbar />
      <main>
        <Hero />
        <LiveNow />
        <Features />
        <Ranking />
        <Hosts />
        <Steps />
        <Reviews />
        <Faq />
        <JoinForm />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}